/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment-variables';

@Injectable()
export class DevRoutesGuard {
	constructor(private router: Router) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (environment.production) {
			console.trace('-----Router Debugger-----');
			this.router.navigate(['/projects']);
			return false;
		} else {
			return true;
		}
	}
}
